module.exports = __webpack_public_path__ + "audio-d95cb52f8429.m4a";